import React from "react";
import { Route, Routes } from "react-router-dom";
import ProtectedPublicRoute from "../components/auth/ProtectedPublicRoutes";
import Login from "../pages/authentication/login";
import Recuperar from "../pages/authentication/recuperar";
import Register from "../pages/authentication/register";
import Home from "../pages/home";

const PublicRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<ProtectedPublicRoute />}>
                <Route path="/home" element={<Home />} />
                <Route path="/login" element={<Login />} />
                <Route path="/registro" element={<Register />} />
                <Route path="/recuperar-contrasenia" element={<Recuperar />} />
            </Route>
        </Routes>
    )
}

export default PublicRoutes;